import axios from 'axios';
import STORAGE from '../enum/Storage';

export const useTokenHandler = () => {
    return axios.create({
        baseURL: process.env.REACT_APP_TOKENHANDLER_DOMAIN,
        withCredentials: true,
        xsrfCookieName: STORAGE.CSRF,
        headers: {
            'Content-Type': 'application/json',
        },
    });
}
